export default __webpack_public_path__ + "static/media/esg-48.4b272fdc.jpg";